import Api from 'services/Api';
import {requestPayload} from 'store/modules/claim';
import Validator from 'services/Validator';
import {previousValid} from 'store/generators/step';

export const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET',
};

// Initial State
const state = {
    periodBetweenOnsetAndAssumedDod: 0,
    claimantReductionInLife: 0,
    discountRate: -0.25,
};

/**
 * Validation Rules.
 *
 * @type {Object}
 */
const rules = {
    periodBetweenOnsetAndAssumedDod: {type: 'number', rules: 'required|min:0.1'},
    claimantReductionInLife: {type: 'number', rules: 'required|min:0.1'},
};

/**
 * Root Validation Rules.
 *
 * This isn't permanent, I think we should make this supported by the normal
 * rules as it allows us to validate a step for data which isn't necessarily
 * stored on that step (but could be input there).
 *
 * @type {Object}
 */
const rootRules = {
    'lost.claimant.theClaimant.onsetOfSymptoms': {type: 'date', rules: 'required'},
    'lost.claimant.theClaimant.assumedLifeExpectancy.dateOfDeath': {type: 'date', rules: 'required'},
};


// Getters
const getters = {
    getClaimInfoValue: state => key => state[key],
};

// Actions
const actions = {
    /**
     * Save the step by submitting to the server.
     *
     * @param payload
     * @param getters
     * @param dispatch
     * @param rootState
     */
    save({getters, dispatch, rootState}, payload) {
        // We might change this to something which 
        // is a bit cleaner...
        payload.data = state;
        payload.data.onset_of_symptoms = rootState.lost.claimant.theClaimant.onsetOfSymptoms;
        payload.data.level_of_education = rootState.lost.claimant.theClaimant.levelOfEducation;
        payload.data.disabled = rootState.lost.claimant.theClaimant.disabledAtAccident;
        payload.data.age_at_death = rootState.lost.claimant.theClaimant.assumedLifeExpectancy.ageAtDeath;

        Api.claims.save(payload).then((response) => {
            return response;
        });

        dispatch('lost/save', requestPayload(0), {root: true});
    },

    /**
     * Loads the step being received from the Server, to be placed in the state.
     *
     * @param dispatch
     * @param action
     * @param commit
     * @param step
     */
    load({dispatch, action, commit}, step) {
        const data = _.deeply(_.mapKeys)(step, (value, key) => _.camelCase(key)).data;
        commit(mutationTypes.UPDATE_VALUE, {key: 'discountRate', value: data.discountRate});
    },

    /**
     * Performs any processing once the data from the server has been stored.
     * This is a good place to do calculations or dispatch other actions which
     * are used to refresh/update calculated data on other steps/components.
     *
     * @param commit
     * @param dispatch
     */
    process({commit, dispatch}) {
        // Nothing needed here yet...
    },

    /**
     * Validates the step once any processing is complete.
     *
     * @param commit
     * @param dispatch
     * @param rootState
     */
    validate({commit, dispatch, rootState}) {
        dispatch('lost/step/setStepNumberValid', {
            stepNo: 1,
            valid: previousValid(rootState, 1)
                && (new Validator(rootState, rootRules)).validate()
                && (new Validator(state, rules)).validate(),
        }, {root: true});
    },

    /**
     * Resets the step back to defaults
     *
     * @param commit
     * @param dispatch
     */
    reset({commit, dispatch}) {
        dispatch('lost/step/setStepNumberValid', {
            stepNo: 1,
            valid: false,
        }, {root: true});

        commit(mutationTypes.RESET);
    },

    /**
     * Update a claim info value
     *
     * @param commit
     * @param key
     * @param value
     */
    updateClaimInfoValue({commit, dispatch}, {key, value}) {
        commit(mutationTypes.UPDATE_VALUE, {key, value});
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.periodBetweenOnsetAndAssumedDod = 0;
        state.claimantReductionInLife = 0;
        state.discountRate = -0.25;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/lost/claimInfo.js